import { memo as _memo } from 'react';
import type { ComponentType, FunctionComponent, PropsWithRef } from 'react';

/**
 * Wraps a component with React's `memo`, but returns a plain function component instead of
 * memo's opaque wrapper object — for easier mocking.
 */
export function memo<P>(comp: ComponentType<P>): FunctionComponent<PropsWithRef<P>> {
	const ReactMemoComponent = _memo(comp);

	return function MemoComponent(props) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		return <ReactMemoComponent {...(props as any)} />;
	};
}
